'use strict';

/**
 * Base class for visible components
* */
class BaseComponent {
	
	/**
	 * jQuery selector to identify component markup in HTML
	 * example: '[data-component]'
	 * example: '#componentId'
	 * @returns {String}
	 * */
	static get templateIdentifier() {
		return null;
	};

	/**
	 * data property name under which instance is attached to dom element
	 * example: '_component'
	 * @returns {String}
	 * */
	static get instanceIdentifier() {
		return '_component';
	};

	/**
	 * default state for this component
 	 * @returns {Object}
	 * */
	static get defaultState() {
		return {
			replaceWrapper: false
		};
	};

	/**
	 * Auto-Initialization of all appearances of this component in the given scope
	 * returns array of instances
	 * @param scope
	 * @returns {Array} instances
	 */
	static autoInit(scope = document) {
		let templateId = this.getTemplateIdentifier();
		let instanceId = this.getInstanceIdentifier();
		let instances = [];

		//autoInit only with templateId and instanceId
		if(templateId && instanceId) {
			//get all dom elements with this templateId
			$(templateId, scope).each((i, el) => {
				let $el = $(el),
					data = $el.data(),
					instance = data[instanceId];

				//if no component instance exists, create new one
				if (!_.isObject(instance)) $el.data(instanceId, (instance = new this(el, data)));

				//remember instance
				instances.push(instance);
			});
		}

		return instances;
	};

	/**
	 * Create new BaseComponent
	 * @param element
	 * @param state
	 * @returns {BaseComponent}
	 */
	constructor(element, state) {
		//dom element
		this.$el = $(element || `<div data-uid="${_.uniqueId()}">`);

		//state
		this.state = $.extend({}, this.constructor.defaultState, this.$el.data(), state);

		//template
		this._view = '<h2>NEW <%= comp %> ANYONE?</h2>';

		//template properties
		this._props = { comp: 'BASE COMPONENT' };

		//internal component state
		this._internalState = {};

		//true if render() has been called at least once
		this._rendered = false;

		//bind 'this' in all functions
		_.bindAll(this, ['render', 'init', 'update', 'destroy']);

		//debug mode
		this.debug = false;
		if(this.debug) console.log('BaseComponent.constructor', this.$el, this.state);

		return this
	}

	/**
	 * renders the component template
	 * uses lodash https://lodash.com/docs#template
	 * @param callAfterRender {boolean} call init immediately after rendering
	 * @param force {boolean} force rendering / rerendering
	 * @returns {BaseComponent}
	 */
	render(force = false) {
		if(this._rendered && !force) {
			console.log('BaseComponent.render already rendered');
			return this;
		}

		if(!this._view || !this._props) {
			console.log('BaseComponent.render missing parameters');
		} else {
			if(this.debug) console.log("BaseComponent.render", this.$el);
			//render template using lodash
			let tpl = _.template(this._view)(this._props);
			if(this.state.replaceWrapper) this.$el.replaceWith(tpl);
			else this.$el.html(tpl);
			this._rendered = true;
		}

		return this
	}

	/**
	 * initialize UI logic, all $('...') goes here
	 * @returns {BaseComponent}
	 **/
	init() {
		if(this.debug) console.log("BaseComponent.init", this.$el);
		return this
	}

	/**
	 * update UI when data or state has changed
	 * @param force {boolean} force update
	 * @returns {BaseComponent}
	 */

	update(force = false) {
		if(!_.isEqual(this._internalState, this.state) || force) {
			//do something
			//then copy state
			this._internalState = _.clone(this.state);
		}

		return this;
	}

	/**
	 * Destroy instance, remove dom element and all references
	 * @returns {BaseComponent}
	 */
	destroy() {
		this.$el.remove();
		_.forIn(this, (value, key) => this[key] = null);
		return this;
	}

	fadeInElement($el) {
		$el.removeClass('fade-hide');
		return this;
	}

	fadeHideElement($el) {
		$el.addClass('fade-in fade-hide');
		return this;
	}
}
